<template>
  <section>
    <v-layout row justify-center pb-4>
      <v-flex xs6 md6 pl-2>
        <v-hover>
          <v-card
            @click="showEditMessageDialog = true"
            v-ripple
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 8 : 2}`"
          >
            <v-card-title primary-title class="headline grey lighten-2">
              <v-icon medium left>textsms</v-icon>
              <span class="title font-weight-light">{{message.prettyName}}</span>
            </v-card-title>
            <v-flex pt-1>
              <v-card-text>{{messageBody}}</v-card-text>
            </v-flex>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs6 md6 pl-5>
        <v-layout row justify-left>
          <EnableMessageSwitch
            :messageKey="this.message.name"
            :enabled="this.message.enabled"
            currentType="sms"
          />
        </v-layout>
        <v-layout row justify-left>
          <v-flex xs6 md6>
            <v-layout row>
              <v-flex shrink pr-2>
                <EditSMSMessage
                  :messageKey="message.name"
                  :messagePrettyName="message.prettyName"
                  :messageBody="messageBody"
                  :messageDescription="message.description"
                  :messageFields="message.fields"
                  :prettyFields="prettyFields"
                  :showEditMessageDialog="showEditMessageDialog"
                  v-on:editDialogClosed="showEditMessageDialog = false"
                  v-on:updatedMessage="updateMessageCard"
                />
              </v-flex>
              <TestMessage
                :messageKey="message.name"
                :messagePrettyName="message.prettyName"
                messageType="sms"
              />
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import EditSMSMessage from "@/components/settings/messages_emails/EditSMSMessage.vue";
import EnableMessageSwitch from "@/components/settings/messages_emails/EnableMessageSwitch.vue";
import TestMessage from "@/components/settings/messages_emails/TestMessage.vue";

export default {
  name: "sms_message_item",
  components: {
    EnableMessageSwitch,
    EditSMSMessage,
    TestMessage
  },
  props: {
    message: Object,
    prettyFields: Object
  },
  data: function() {
    return {
      messageBody: null,
      showEditMessageDialog: false
    };
  },
  methods: {
    updateMessageCard: function(newValue) {
      this.messageBody = newValue;
    }
  },
  beforeMount: function() {
    this.messageBody = this.message.value;
  }
};
</script>